
///
/// EarthBrowser
///
/// Created by Matt Giger on 1/17/2025
/// Copyright (c) 2025 Geodata Labs
///

import { isDevelopment } from '@/utils/environment'
import { ConsoleLogger, EmptyLogger } from '@stovokor/utils/logging'
import type { LoggingInterface } from '@stovokor/utils/logging'

// Unified logging interface
class LogDispatcher implements LoggingInterface {
	private loggers: LoggingInterface[] = []

	constructor() {
		const debug = isDevelopment()

		this.loggers.push(debug ? new ConsoleLogger() : new EmptyLogger())
	}

	addLogger(loggingInterface: LoggingInterface): void {
		this.loggers.push(loggingInterface)
	}

	log(message: string, ...params: unknown[]): void {
		this.loggers.forEach(l => l.log(message, params))
	}
	info(message: string, ...params: unknown[]): void {
		this.loggers.forEach(l => l.info(message, params))
	}
	warn(message: string, ...params: unknown[]): void {
		this.loggers.forEach(l => l.warn(message, params))
	}
	error(error: unknown, ...params: unknown[]): void {
		this.loggers.forEach(l => l.error(error, params))
	}
	assert(condition: boolean, message: string, ...params: unknown[]): void {
		this.loggers.forEach(l => l.assert(condition, message, params))
	}
}

export class logger {
	private static _logger?: LogDispatcher
	private static get instance(): LogDispatcher {
		if(!this._logger) {
			this._logger = new LogDispatcher()
		}
		return this._logger
	}

	public static log(message: string, ...params: unknown[]): void {
		logger.instance.log(message, params)
	}
	public static info(message: string, ...params: unknown[]): void {
		logger.instance.info(message, params)
	}
	public static warn(message: string, ...params: unknown[]): void {
		logger.instance.warn(message, params)
	}
	public static error(error: unknown, ...params: unknown[]): void {
		logger.instance.error(error, params)
	}
	public static assert(condition: boolean, message: string, ...params: unknown[]): void {
		logger.instance.assert(condition, message, params)
	}

	/**
	 * Attach an extra logging sink. The Sentry logger registers itself here
	 * from initSentry() (app/sentry.ts) instead of being constructed
	 * inline, so this module - imported by the engine's asset loaders -
	 * doesn't pull the Sentry SDK into store-less builds (the /embed entry)
	 */
	public static addLogger(loggingInterface: LoggingInterface): void {
		logger.instance.addLogger(loggingInterface)
	}
}